import { Avatar, Link, Stack, Typography } from '@mui/material';
import { ISubCategory } from 'API/UniversalRequest/universalRequest';
import { getDisabilityConfirmationPdf } from 'API/disabilityConfirmation';
import { Loader } from 'Components';
import { useIsDesktop } from 'Hooks';
import {
  Download,
  LeftArrow,
  UniversalRequestFullPurpleExclamationMark,
} from 'Images';
import { downloadFile } from 'Utils';
import { useState } from 'react';

interface IPersonalAreaRecommendation {
  linkUrl: string;
  isDownload?: boolean;
  isDisabledVeteran: boolean;
  subCategory?: ISubCategory;
}

export const PersonalAreaRecommendation = ({
  linkUrl,
  isDownload,
  isDisabledVeteran,
  subCategory,
}: IPersonalAreaRecommendation) => {
  const isDesktop = useIsDesktop();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Stack
      width={isDesktop ? '680px' : 'calc(100% - 48px)'}
      p={isDesktop ? '24px' : '16px'}
      bgcolor={isDesktop ? 'white' : '#FBF6FF'}
      border='1px solid #B756FF'
      m='0 auto'
      direction='row'
      gap='8px'
      borderRadius='12px'
      mt='60px'
    >
      <Avatar
        src={UniversalRequestFullPurpleExclamationMark}
        alt=''
        sx={{ width: '24px', height: '24px' }}
      />
      <Stack>
        <Typography fontSize={isDesktop ? '20px' : '18px'} lineHeight='24px'>
          {subCategory?.onlineFormAlertText}
        </Typography>
        <Typography
          maxWidth='52ch'
          mt={isDesktop ? '8px' : '4px'}
          fontSize={isDesktop ? '20px' : '18px'}
          lineHeight='24px'
        >
          {subCategory?.onlineFormLinkPrefixText}
        </Typography>
        <Link
          underline='none'
          href={
            isDownload || subCategory?.isOpenLinkInNewTab
              ? undefined
              : subCategory?.onlineFormLink
          }
          sx={{
            display: 'flex',
            mt: '4px',
            gap: '4px',
          }}
          onClick={
            subCategory?.isOpenLinkInNewTab
              ? () => window.open(subCategory?.onlineFormLink)
              : isDownload
              ? async () => {
                  setIsLoading(true);
                  const id = linkUrl.split('/').pop();

                  const file = await getDisabilityConfirmationPdf(
                    parseInt(id || '')
                  );

                  if (file?.file) downloadFile(file.file, 'pdf', '');

                  setIsLoading(false);
                }
              : undefined
          }
        >
          <Typography
            fontWeight='600'
            fontSize={isDesktop ? '18px' : '16px'}
            lineHeight={isDesktop ? '22px' : '20px'}
            minWidth={isLoading ? 'fit-content' : undefined}
          >
            {subCategory?.onlineFormLinkText}
          </Typography>
          {isLoading ? (
            <Loader
              sx={{
                height: '100%',
                overflow: 'hidden',
                display: 'inline',
                ml: '8px',
              }}
              size={20}
            />
          ) : (
            <Avatar
              src={isDownload || isDisabledVeteran ? Download : LeftArrow}
              alt=''
              sx={{
                width: '24px',
                height: '24px',
                ml: isDesktop ? undefined : '-4px',
                mt: isDesktop ? undefined : '-2px',
              }}
            />
          )}
        </Link>
        <Typography
          mt={isDesktop ? '16px' : '12px'}
          fontWeight='600'
          fontSize={isDesktop ? '18px' : '16px'}
          lineHeight={isDesktop ? '22px' : '20px'}
        >
          {subCategory?.onlineFormLinkSuffixText}
        </Typography>
      </Stack>
    </Stack>
  );
};
